// File: frontend/src/components/upload/SectionProgress.js

import React from 'react';
import { 
  FileText, 
  Building2, 
  User, 
  Car, 
  Home, 
  Users, 
  Shield, 
  FileCheck, 
  XCircle, 
  DollarSign, 
  Star, 
  TrendingUp, 
  Briefcase, 
  Sparkles,
  Check,
  Loader2
} from 'lucide-react';
import styles from './SectionProgress.module.css';

const SECTION_CONFIG = {
  'POLICY_METADATA': { label: 'Policy Details', icon: FileText },
  'INSURANCE_COMPANY': { label: 'Insurance Company', icon: Building2 },
  'INSURED_INFORMATION': { label: 'Insured Information', icon: User },
  'VEHICLES': { label: 'Vehicles', icon: Car },
  'PROPERTIES': { label: 'Properties', icon: Home },
  'DRIVERS': { label: 'Drivers', icon: Users },
  'COVERAGES': { label: 'Coverages', icon: Shield },
  'ENDORSEMENTS': { label: 'Endorsements', icon: FileCheck },
  'DECLINED_COVERAGES': { label: 'Declined Coverages', icon: XCircle },
  'PREMIUM_BILLING': { label: 'Premium & Billing', icon: DollarSign },
  'RATING_INFORMATION': { label: 'Rating Factors', icon: Star },
  'CLAIMS_HISTORY': { label: 'Claims History', icon: TrendingUp },
  'AGENT_INFORMATION': { label: 'Agent Details', icon: Briefcase },
  'ADDITIONAL_DETAILS': { label: 'Additional Details', icon: Sparkles }
};

const SectionProgress = ({ currentSection, completedSections, allSections }) => {
  const getSectionStatus = (sectionId) => {
    if (completedSections.includes(sectionId)) return 'completed';
    if (currentSection === sectionId) return 'active';
    return 'pending';
  };

  const getSectionConfig = (sectionId) => {
    return SECTION_CONFIG[sectionId] || {
      label: sectionId.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase()),
      icon: FileText
    };
  };

  const getStatusIcon = (status, IconComponent) => {
    if (status === 'completed') {
      return <Check size={16} strokeWidth={2} />;
    }
    if (status === 'active') {
      return <Loader2 size={16} strokeWidth={2} className={styles.spinner} />;
    }
    return <IconComponent size={16} strokeWidth={2} />;
  };

  return (
    <div className={styles.sectionProgress}>
      <h3 className={styles.title}>Extraction Progress</h3>
      <div className={styles.sectionList}>
        {allSections.map((sectionId) => {
          const status = getSectionStatus(sectionId);
          const config = getSectionConfig(sectionId);
          
          return (
            <div 
              key={sectionId} 
              className={`${styles.section} ${styles[status]}`}
            >
              <div className={styles.sectionIcon}>
                {getStatusIcon(status, config.icon)}
              </div>
              <div className={styles.sectionLabel}>
                {config.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SectionProgress;